import type { Coord } from "@dailywars/core/engine";

export function getTileFromPointer({
  canvas,
  clientX,
  clientY,
  boardWidth,
  boardHeight,
}: {
  canvas: HTMLCanvasElement;
  clientX: number;
  clientY: number;
  boardWidth: number;
  boardHeight: number;
}): Coord | null {
  const rect = canvas.getBoundingClientRect();
  if (rect.width <= 0 || rect.height <= 0) return null;

  const x = Math.floor(((clientX - rect.left) / rect.width) * boardWidth);
  const y = Math.floor(((clientY - rect.top) / rect.height) * boardHeight);
  if (x < 0 || y < 0) return null;
  return { x, y };
}
